module.exports = __webpack_public_path__ + "static/media/avaliacoes_active.e31281e4.svg";